module.exports = __webpack_public_path__ + "img/q3_2021.f9713d98.jpg";